export function getTestCases(successResponse) {
  const testCases = new Map();

  testCases.set('success', (resolve, _reject) => {
    resolve(successResponse);
  });
  testCases.set('failure', (_resolve, reject) => {
    reject(false);
  });
  testCases.set('aborted', (_resolve, reject) => {
    reject(true);
  });
  return testCases;
}
